(function() {
    'use strict';


    var extDeps = ['ngResource','ui.router', 'ngRaven','angularMoment','debounce','ngLodash','ngTouch']; //,'ngSanitize','ngStorage'

    var appDeps = [
        'app.common.infra'
        , 'app.common.apis'
        , 'app.common.services'
        , 'app.common.widgets.modal'
        , 'app.common.widgets.general'
        , 'app.common.widgets.hacks'
        , 'app.common.widgets.commands'
        , 'app.common.widgets.notifications'
        , 'app.common.widgets.calendar'
        , 'app.common.widgets.spinner'
        , 'app.common.widgets.notes'

    ];

    var module = angular.module('app.common', extDeps.concat(appDeps));


    /**
     * Configures the default states to bootstrap the back button across the board
     */
    module.config(configureStates);
    configureStates.$inject = ['$stateProvider'];
    function configureStates($stateProvider) {

        $stateProvider
            .state('enterModule',{
                params: {   name: '', payload: {}}
                , onEnter: onEnterFunc
            });


        onEnterFunc.$inject = ['$stateParams', '$q', '$injector','$window'];
        function onEnterFunc($stateParams, $q, $injector, $window ){
            getDestinationUrlAsync($stateParams.name || '', $q, $injector, $stateParams.payload)
                .then(function(result){
                    $window.location = result;
                });
            return false;
        }


        function getDestinationUrlAsync(moduleName,$q, $injector , payload){
            var rt = '';

            if(moduleName.match(/^roster$/i))
                rt = '/roster';
            else if(moduleName.match(/^payabletime$/i))
                rt = '/payabletime';
            else if(moduleName.match(/^news$/i)){
                rt = '/news';
                if(payload.id){
                    //raiseEvent('uiRouter.routeChanged', $injector);
                    rt += '/#' + payload.id + '?nav=0';
                }
            }
            else if(moduleName.match(/^leave$/i))
                rt = '/leave';
            else if(moduleName.match(/^payslips$/i))
                rt = '/payslips';
            else if(moduleName.match(/^userProfile$/i))
                rt = '/userprofile';
            else if(moduleName.match(/^feedback$/i))
                rt = '/feedback';
            else if(moduleName.match(/^home/i))
                rt = '/';
            else if(moduleName.match(/^tour/i))
                rt = '/tour';
            else if(moduleName.match(/^logout/i))
                rt= $injector.get('appGlobals').signoutUrl;
            else if(moduleName.match(/^layouts/i))
                rt = '/ui/layouts/';
            else if(moduleName.match(/^devconfig/i))
                rt ='/devconfig';
            else if(moduleName.match(/^timesheets/i))
                rt ='/timesheets';

            return $q.resolve(rt);

        }

        function raiseEvent(eventName, $injector){
            $injector.get('$rootScope').$emit(eventName);
        }

    }


    module.config(configureNgTouch);
    configureNgTouch.$inject = ['$touchProvider'];
    function configureNgTouch($touchProvider) {

        $touchProvider.ngClickOverrideEnabled(false);

    }


    /**
     * PROVIDER
     */


    module.provider('pageInfo',pageInfoProvider);
    pageInfoProvider.$inject = [];
    function pageInfoProvider(){

        var _info = {};

        return {
            setPageInfo: function(info){
                _info = info;
            },
            $get: function () {
                return _info;
            }
        };
    }


})();

